import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import AppBar from '@mui/material/AppBar'
import IconButton from '@mui/material/IconButton'
import MuiToolbar from '@mui/material/Toolbar'
import { has, isEmpty } from 'lodash'
import { createSearchParams, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { BucketMedia } from '../../../../../graphql/generated'
import MediaIconMenu from './MediaMenu'
import { drawerVar } from '../../../../../providers/apollo/cache'

interface Props {
  media: BucketMedia | null
  handleClose: () => void
}

interface CustomizedUri {
  returnUri: string
}

export default function Toolbar({ media, handleClose }: Props) {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const action = searchParams.get('action')
  const close = searchParams.get('close')
  const navigate = useNavigate()
  const uri: CustomizedUri = has(location.state, 'returnUri') ? (location.state as CustomizedUri) : { returnUri: '' }
  const { returnUri = '' } = uri
  const { shareId, mode } = useParams<{ shareId: string; mode: 'slideshow' }>()

  const handleClick = () => {
    let pathname = ''
    let search: string | undefined

    if (returnUri) {
      pathname = returnUri
    } else if (shareId) {
      pathname = `/share/${shareId}`
    }

    const qs: { scrollTo?: string; q?: string } = {}

    if (media) {
      qs.scrollTo = media.id
    }

    if (searchParams.get('q')) {
      qs.q = searchParams.get('q') ?? undefined
    }

    if (!isEmpty(qs)) {
      search = `?${createSearchParams(qs)}`
    }

    drawerVar(null)
    navigate({ pathname, search })
  }

  if (mode === 'slideshow' && close?.toLowerCase() !== 'true') {
    return null
  }

  if (mode === 'slideshow' || action === 'focus') {
    return (
      <MuiToolbar disableGutters style={{ color: 'white' }}>
        <IconButton color="inherit" onClick={handleClose} data-test="close-slideshow" size="large">
          <CloseIcon fontSize="small" />
        </IconButton>
      </MuiToolbar>
    )
  }

  return (
    <AppBar position="static" elevation={0} color="inherit" sx={{ color: 'primary.main' }}>
      <MuiToolbar>
        <IconButton onClick={handleClick}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'end' }}>
          <MediaIconMenu media={media} />
        </div>
      </MuiToolbar>
    </AppBar>
  )
}
